var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiDefaultActionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8.39999L5.5 3.20999",
    stroke: "#0688FA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15V6.99999C18.9996 6.64927 18.9071 6.3048 18.7315 6.00116C18.556 5.69751 18.3037 5.44536 18 5.26999L11 1.26999C10.696 1.09446 10.3511 1.00204 10 1.00204C9.64893 1.00204 9.30404 1.09446 9 1.26999L2 5.26999C1.69626 5.44536 1.44398 5.69751 1.26846 6.00116C1.09294 6.3048 1.00036 6.64927 1 6.99999V15C1.00036 15.3507 1.09294 15.6952 1.26846 15.9988C1.44398 16.3025 1.69626 16.5546 2 16.73L9 20.73C9.30404 20.9055 9.64893 20.9979 10 20.9979C10.3511 20.9979 10.696 20.9055 11 20.73L18 16.73C18.3037 16.5546 18.556 16.3025 18.7315 15.9988C18.9071 15.6952 18.9996 15.3507 19 15Z",
    stroke: "#0688FA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.27 5.95999L10 11.01L18.73 5.95999",
    stroke: "#0688FA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 21.08V11",
    stroke: "#0688FA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiDefaultActionIcon);
export default __webpack_public_path__ + "static/media/ai-default-action-icon.b2954fd187a52c66f3c72bbebb651006.svg";
export { ForwardRef as ReactComponent };